import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  InfrastructureArchitectureInterface,
  InfrastructureArchitectureRequestData,
} from "./utils/types/types";

const initialState: InfrastructureArchitectureInterface = {
  selectDrawerExpanded: true,
  recommendationDrawerExpanded: false,
  requestData: {},
};

export const infrastructureArchitectureSlice = createSlice({
  name: "infrastructureArchitecture",
  initialState: initialState,
  reducers: {
    toggleSelectDrawerExpanded: (state) => {
      state.selectDrawerExpanded = !state.selectDrawerExpanded;
    },
    toggleRecommendationDrawerExpanded: (state) => {
      state.recommendationDrawerExpanded = !state.recommendationDrawerExpanded;
    },
    setInfrastructureArchitectureRequestData: (
      state,
      action: PayloadAction<InfrastructureArchitectureRequestData>,
    ) => {
      state.requestData = {
        ...state.requestData,
        ...action.payload,
      };
    },
  },
});

export const {
  toggleSelectDrawerExpanded,
  toggleRecommendationDrawerExpanded,
  setInfrastructureArchitectureRequestData,
} = infrastructureArchitectureSlice.actions;

export default infrastructureArchitectureSlice.reducer;
